import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`

export const Icon = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  margin-right: 2rem;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DropdownContainer = styled.div`
  width: 100%;
  position: relative;
  user-select: none;
`

export const DropdownHeader = styled.div<{ $isOpen: boolean }>`
  min-height: 4.5rem;
  padding: 0.1rem 0 0 0.8rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: ${(p) => (p.$isOpen ? '0.5rem 0.5rem 0 0' : '0.5rem')};
  transition: all 0.2s;
  cursor: pointer;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0 0.5rem 0 transparent;
  user-select: none;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    &:hover,
    &:focus {
      border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
    }
  }
`

export const DropdownContent = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-top: none;
  border-radius: 0 0 0.5rem 0.5rem;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  display: ${(p) => (p.$isOpen ? 'block' : 'none')};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

export const OptionItem = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 1px solid ${(p) => p.theme.colors.greyLighter};

  &:hover {
    background: ${(p) => p.theme.colors.greyLighter};
  }
`

export const OptionLabel = styled.span<{ $selected: boolean }>`
  font-weight: ${(p) => (p.$selected ? '600' : '400')};
  color: ${(p) => (p.$selected ? p.theme.colors.turquoiseDark : 'inherit')};
  flex: 1;
`

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ToggleButton = styled.button<{ $active: boolean; $type: 'include' | 'exclude' }>`
  padding: 0.3rem 0.8rem;
  border: 1px solid;
  border-radius: 0.3rem;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s;

  ${(p) => {
    if (p.$active && p.$type === 'include') {
      return `
        background: #dcf4e5;
        border-color: #dcf4e5;
        color: rgb(9, 174, 76);
      `;
    }
    if (p.$active && p.$type === 'exclude') {
      return `
        background: #fbe7e6;
        border-color: #fbe7e6;
        color: #d53538;
      `;
    }
    return `
      background: white;
      border-color: ${p.theme.colors.greyLight};
      color: ${p.theme.colors.greyDarker};

      &:hover {
        border-color: ${p.theme.colors.turquoiseDark};
      }
    `;
  }}
`

export const SelectedCount = styled.span<{ $isPlaceholder: boolean }>`
  margin-left: ${(p) => (p.$isPlaceholder ? '1.8rem' : '0.8rem')};
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.4rem;
  padding: ${(p) => (p.$isPlaceholder ? '0' : '0.8rem 0')};
  user-select: none;
`

export const SelectedItems = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.7rem;
  padding: 0.4rem 0 0.4rem 0.8rem;
  user-select: none;
`

export const SelectedItem = styled.div<{ $include?: boolean }>`
  padding: 0 0.5rem 0 0.5rem;
  background: ${(p) => {
    if (p.$include === true) return '#dcf4e5';
    if (p.$include === false) return '#fbe7e6';
    return p.theme.colors.greyLighter;
  }};
  color: ${(p) => {
    if (p.$include === true) return 'rgb(9, 174, 76)';
    if (p.$include === false) return '#d53538';
    return 'inherit';
  }};
  display: flex;
  align-items: center;
  margin: 0;
  height: 2.8rem;
  border-radius: 0.2rem;
  font-size: 1.3rem;
`

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 2px;
  width: auto;
  height: auto;
  font-weight: bold;
  border-radius: 10px;

  svg {
    fill: ${(p) => p.theme.colors.black};
    width: 12px;
    height: 12px;
    stroke: ${(p) => p.theme.colors.black};
    stroke-width: 50px;
    font-weight: bold;
  }

  &:hover {
    background: ${(p) => p.theme.colors.errorBackground};

    svg {
      fill: ${(p) => p.theme.colors.errorText};
      stroke: ${(p) => p.theme.colors.errorText};
    }
  }
`

export const ChevronIcon = styled.span<{ $isOpen: boolean }>`
  transform: ${(p) => (p.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
  margin-right: 1.6rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDarker};
  user-select: none;
`
